import React, { useState } from 'react';

import Header from '../../main/components/Header';
import MobileBottomBar from '../../main/components/MobileBottomBar';
import Path from '../../path/ui/Path';

import { I18nextProvider } from 'react-i18next';
import i18n from '../../../language/i18n';
import TariffsContent from '../components/TariffsContent';
import { t } from 'i18next';

function Main() {
    const [bottomBarHidden, setBottomBarHidden] = useState(false);

    const handleBottomBarToggle = (isHidden) => {
        setBottomBarHidden(isHidden);
    };

    return (
        <I18nextProvider i18n={i18n}>
            <Header onToggleMenu={handleBottomBarToggle} />
            <Path currentPath={t('tariffs')} />
            <TariffsContent />
            {!bottomBarHidden && <MobileBottomBar activeTabName={'profile'} />}
        </I18nextProvider>
    );
}

export default Main;
